import {
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAIL,
  DISABLE_USER_SUCCESS,
  DISABLE_USER_FAIL,
  ENABLE_USER_SUCCESS,
  ENABLE_USER_FAIL,
  SET_MESSAGE,
} from "./types";

import UserService from "../services/user.service";

//Cuando se utiliza una acción que retorna un mensaje que debe ser desplegado en el web indicando el éxito o el fracaso de la operación.
//Se utiliza mecanismo de mensajeria en dispatch.
export const editUser = (objUser, isCurrentUser) => (dispatch) => {
  return UserService.editUser(objUser, isCurrentUser).then(
    (response) => {
      dispatch({
        type: EDIT_PROFILE_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: EDIT_PROFILE_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const disableUser = (userName) => (dispatch) => {
  return UserService.disableUser(userName).then(
    (response) => {
      dispatch({
        type: DISABLE_USER_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: DISABLE_USER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const enableUser = (userName) => (dispatch) => {
  return UserService.enableUser(userName).then(
    (response) => {
      dispatch({
        type: ENABLE_USER_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: ENABLE_USER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

//Cuando se utiliza una acción que retorna un set de datos el cual debe ser procesado en el js que gatilla la acción se debe solo llamar al servicio.
//Esto para que el response llegue al origen de la llamada y pueda ser procesada/pintada.
export const getUser = (username) => (dispatch) => {
  return UserService.getUser(username)
};